import { AppUI } from '@seedlang/state';

const MobileOnly = ({ children }) => {
  if (!AppUI.layout.isMobile) {
    return null;
  }

  return children;
};

export default MobileOnly;